// extracted by css-extract-rspack-plugin
var _1 = "uo4NW";
var _2 = "LZQXd";
var _3 = "PBZZA";
var _4 = "umT7X";
var _5 = "uHRiM";
var _6 = "SsIaw";
var _7 = "gj8it";
export { _1 as "clickDisabled", _2 as "container", _3 as "noTextAnimation", _4 as "saved", _5 as "showOnlyOnHover", _6 as "starIcon", _7 as "starIconBase" }
